import baseStyles from '../sass/base.scss';
import mobileMenuJS from './includes/mobile_menu.js';
import customFancyboxJS from './includes/custom_fancybox.js';
import customScrollsJS from './includes/custom_scrolls.js';
import customTabsJS from './includes/custom_tabs.js';
import ratingFieldJS from './includes/rating_field.js';
import commonSwiperSliderJS from './includes/common_swiper_slider.js';
import backToTopJS from './includes/back_to_top.js';
import customFAQJS from './includes/custom_faq.js';
import customPriceSliderJS from './includes/custom_price_slider.js';
import smoothScrollToJS from './includes/smooth_scroll_to.js';
import sideMenuSelectJS from './includes/side_menu_select';
import headerCatalogJS from './includes/header_catalog.js';
import searchBarJS from './includes/search_bar.js';

const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight();

$(document).ready(function() {
    $('.selectric-select').selectric({
        maxHeight: 360,
        disableOnMobile: false,
        nativeOnMobile: true
    });
});
